// extracted by mini-css-extract-plugin
export var brand = "_80-8";
export var compact = "_80-5";
export var extraSmall = "_80-6";
export var icon = "_80-0";
export var large = "_80-3";
export var light = "_80-1";
export var medium = "_80-4";
export var outline = "_80-a";
export var primaryDark = "_80-9";
export var primaryLight = "_80-7";
export var primaryModern = "_80-b";
export var success = "_80-2";